import { Navigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import AuthContext from "../Services/Auth";
import GlobalContext from "../GlobalContext";

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const PrivateRoute = ({ children, ...rest }) => {
  const { authTokens } = useContext(AuthContext);

  const [display, setDisplay] = useState(false);

  useEffect(() => {
    const await_background_process = async () => {
      await sleep(500);
      setDisplay(true);
    };

    await_background_process()
  }, [authTokens])

  if(!display){
    return (
      <div className="w-full h-full flex justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" style={{height:"70px", width:"70px"}}>
          <radialGradient id="a8" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
            <stop offset="0" stop-color="#0278f5"></stop>
            <stop offset=".3" stop-color="#0278f5" stop-opacity=".9"></stop>
            <stop offset=".6" stop-color="#0278f5" stop-opacity=".6"></stop>
            <stop offset=".8" stop-color="#0278f5" stop-opacity=".3"></stop>
            <stop offset="1" stop-color="#0278f5" stop-opacity="0"></stop>
          </radialGradient>
          <circle transform-origin="center" fill="none" stroke="url(#a8)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
            <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite">
            </animateTransform>
          </circle>
          <circle transform-origin="center" fill="none" opacity=".2" stroke="#0278f5" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70">
          </circle>
        </svg>
      </div>
    )
  }

  return authTokens ? children : <Navigate to="/Login" />;
};

export default PrivateRoute;